//for L&TT home Url Api call only
export const baseUrl = "https://atci.lkm.accenture.com/lttmicrosite-apis"
//